/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AuthorisationSettings } from './authorisationSettings';
import { CounselRole } from './counselRole';
import { Doctor } from './doctor';
import { GeneralProfileData } from './generalProfileData';
import { Individual } from './individual';
import { MedStaff } from './medStaff';
import { Organization } from './organization';
import { Patient } from './patient';
import { Reaction } from './reaction';
import { Researcher } from './researcher';
import { UserExtended } from './userExtended';
import { UserRole } from './userRole';

export interface FullUser extends UserExtended { 
    profile: GeneralProfileData;
    organization?: Organization;
    individual?: Individual;
    patient?: Patient;
    doctor?: Doctor;
    med_staff?: MedStaff;
    researcher?: Researcher;
    authorisation_settings?: AuthorisationSettings;
}